export default ["ROLE_ADMIN", "ROLE_SUPERADMIN", "ROLE_AGENT", "ROLE_AGENCYADMIN"];
